.base {
	background-color: var(--lp-color-bg-ui-primary);
	border-radius: 100%;
}

.small {
	width: var(--lp-size-16);
	height: var(--lp-size-16);
}

.medium {
	width: var(--lp-size-24);
	height: var(--lp-size-24);
}

.large {
	width: var(--lp-size-40);
	height: var(--lp-size-40);
}

.initials {
	font: var(--lp-text-label-1-semibold);
	font-size: var(--lp-font-size-100);
}

.yellow {
	background-color: var(--lp-color-brand-yellow-dark);
}

.blue {
	background-color: var(--lp-color-blue-600);
}

.pink {
	background-color: var(--lp-color-brand-pink-base);
}

.cyan {
	background-color: var(--lp-color-brand-cyan-base);
}

.purple {
	background-color: var(--lp-color-purple-600);
}

.text {
	fill: var(--lp-color-white-950);
	text-anchor: middle;
	dominant-baseline: central;
}
